// jQuery Loads
// import './config/jqueryLoads';

import { ajaxTest } from "./ajax/ajax_test";
import { syncCarData } from "./ajax/call_syncCar";
import { syncImgData } from "./ajax/call_syncImg";
import { compareAndDelete } from "./ajax/call_compare";
import { updateAndDelete } from "./ajax/call_update";
import { clearCarDbTables, clearImgDbTable } from "./ajax/call_clearDbTables";
import { filterArchive, filterHeader } from "./ajax/fontend_filter";
import { setupBuyForm } from "./ajax/call_setupBuyForm";

jQuery("body").on("change", "#select-brand", function () {
  var brand = $(this).val();

  if (brand != "") {
    var data = {
      action: "get_brands_by_ajax",
      brand: brand,
      security: md_object.nonce,
    };
    jQuery.post(md_object.ajaxurl, data, function (response) {
      console.log(response);
      $("#test-result").html(response);
    });
  }
});

jQuery(function () {
  jQuery("#jx-select-brand-detail").on("change", function () {
    var selectedBrand = jQuery(this).val();
    if (selectedBrand) {
      var el = jQuery("#jx-select-model-detail-container");
      // if (selectedBrand === 'all') {
      // 	el.css('display', 'none');
      // 	return;
      // } else {
      // 	el.css('display', 'block');
      // }
    }

    jQuery.ajax({
      url: md_object.ajaxurl, // This is a global variable provided by WordPress
      type: "POST",
      data: {
        action: "get_models_by_brand", // Custom AJAX action to fetch models
        brand: selectedBrand,
        security: md_object.nonce,
      },
      success: function (response) {
        jQuery("#jx-select-model-detail").html(response); // Update the models dropdown
      },
    });
  });
});

jQuery(() => {
  filterArchive();
  filterHeader();
  setupBuyForm();
});

jQuery.ajaxSetup({
  type: "post",
  url: md_object.ajaxurl,
  error: function (err) {
    console.log(err);
  },
});

jQuery("#ajax-load").click(() => {
  ajaxTest();
});

let btnLoadCars = jQuery("#md-load-cars");
let btnLoadImgs = jQuery("#md-load-imgs");
let btnCompare = jQuery("#md-compare");
let btnClearCarTables = jQuery("#md-clear-car-db");
let btnClearImgTables = jQuery("#md-clear-img-db");
let btnUpdate = jQuery("#md-update-db");

btnLoadCars.click(() => {
  syncCarData();
});

btnLoadImgs.click(() => {
  syncImgData();
});

btnClearCarTables.click(() => {
  clearCarDbTables();
});

btnClearImgTables.click(() => {
  clearImgDbTable();
});

btnCompare.click(() => {
  compareAndDelete();
});

btnUpdate.click(() => {
  updateAndDelete();
});
